import React from "react";
import loader from "../../images/loader.gif";

export function Spinner(props) {
  return (
    <div>
      {props.showLoader && (
        <div
          id="divLoading"
          style={{
            background: "#E9E9E9",
            margin: "0px",
            padding: "0px",
            position: "fixed",
            right: "0px",
            top: "0px",
            width: "100%",
            height: "100%",
            opacity: "0.9"
          }}
        >
          <p
            style={{
              position: "absolute",
              color: "black",
              top: "50%",
              left: "45%"
            }}
          >
            <span id={"uploadProgressMsg"}>Please wait...</span>
            <img src={loader} style={{ width: "30px" }} />
          </p>
        </div>
      )}
    </div>
  );
}
